import script from "./ServiceView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceView.vue?vue&type=script&setup=true&lang=js"

import "./ServiceView.vue?vue&type=style&index=0&id=0eefe740&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.32_webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eefe740"]])

export default __exports__